import { FallbackProps, useErrorBoundary } from "react-error-boundary";
import { AppError } from "../Types";
import "./Components.css";
import { useTranslation } from "react-i18next";

/**
 * エラーが発生したときに表示する画面のコンポーネントです。
 * @param props - プロパティ
 * @returns エラーが発生したときに表示する画面のコンポーネント
 */
export const ErrorContent = (props: FallbackProps) => {
  const { error } = { ...props };
  const { resetBoundary } = useErrorBoundary();
  const { t } = useTranslation();

  const getErrorMessage = () => {
    const tempError = error as AppError;
    if (tempError instanceof Error) {
      return error.message;
    } else {
      return error;
    }
  };

  const errorMessage = getErrorMessage();

  return (
    <div className="rcui-error">
      <div className="mb-4">{t("error.message")}</div>
      <div className="mb-4">{errorMessage}</div>
      <button
        className="text-black border border-gray-400 bg-gray-200 hover:bg-gray-100 rounded px-4 py-2"
        onClick={resetBoundary}
      >
        {t("error.retryButton")}
      </button>
    </div>
  );
};
